// Service de saisie du PIN CPS a la demande (conformite : PIN transitoire, jamais stocke).
// La decision repose sur le statut cryptoki de la carte, demande a MAUI (action StatutCPS).
// CPS_Status natif : 0 UNDEFINED, 1 NON_PRESENTE, 2 CHANGED, 3 ACTIVE.
import RequestManager from '@/script/request';

let _resolverPin = null;
let _resolverStatut = null;
const DELAI_STATUT_MS = 4000;

// Demande le statut cryptoki de la CPS au natif (round-trip). Repli sur UNDEFINED (0)
// -> fenetre PIN, si le natif ne repond pas (ex. hors WebView) : cote sur (on demande le PIN).
export function demanderStatutCPS() {
    return new Promise((resolve) => {
        _resolverStatut = resolve;
        RequestManager.EnvoyerMessageWebView({ action: 'StatutCPS', parameters: [] });
        setTimeout(() => {
            if (_resolverStatut) { const r = _resolverStatut; _resolverStatut = null; r(0); }
        }, DELAI_STATUT_MS);
    });
}

// Appelee par App.vue a la reception de l'action native StatutCPS.
export function recevoirStatutCPS(statut) {
    const r = _resolverStatut; _resolverStatut = null;
    if (r) r(Number(statut));
}

// Ouvre la fenetre PIN, resout avec le code saisi (rejette si annule).
export function demanderPin(store) {
    return new Promise((resolve, reject) => {
        _resolverPin = { resolve, reject };
        store.commit('Cps/setPinDialogVisible', true);
    });
}
export function resoudrePin(store, code) {
    store.commit('Cps/setPinDialogVisible', false);
    const r = _resolverPin; _resolverPin = null;
    if (r) r.resolve(code);
}
export function annulerPin(store) {
    store.commit('Cps/setPinDialogVisible', false);
    const r = _resolverPin; _resolverPin = null;
    if (r) r.reject(new Error('Saisie du PIN annulee'));
}

// Regle centrale. options.forcer = true : PIN obligatoire meme si ACTIVE (ex. 1er lot d'une serie).
// Renvoie "" si carte ACTIVE (et non force), le code saisi sinon ; jette si carte non presente
// ou si l'utilisateur annule.
export async function demanderPinSiRequis(store, options) {
    const forcer = !!(options && options.forcer);
    const statut = await demanderStatutCPS();
    if (statut === 1) throw new Error('Carte CPS non presente');
    if (statut === 3 && !forcer) return '';
    return await demanderPin(store);
}
